import React, {Component} from 'react';
import ChangeEmailView from './ChangeEmailView';

class MainChangeEmailContainerView extends Component {
    render() {
        return (
            <div className="main-settings-wrapper">
                <ChangeEmailView/>
            </div>
        );
    }
}

export default MainChangeEmailContainerView;
